import React, { useState } from 'react'
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Offcanvas from 'react-bootstrap/Offcanvas';
import heartpng from '../Images/logoimg.png'
import logo from '../Images/logo.png'

import '../App.css'
import Contact from './Contact';
import { Link } from 'react-router-dom';
import { logRoles } from '@testing-library/react';
function Header() {
  const [color,setColor] = useState(false);
  const changeColor= () => {
      if((window.scrollY>=1)){
        setColor(true);
      }
      else{
        setColor(false);
      }
  }
  window.addEventListener('scroll', changeColor)
  return (
    <>
    <Navbar id={color?"navbarclass":"navbarchange"}  className='nav rounded-bottom'  data-bs-theme="dark">
        <Container>
          {
            !color ? <img className='heartpng' src={logo} width={50} alt="" />: <p></p>
          }
          <Navbar.Brand id= {color?"navbarbrandclass":"navbarbrandchange"} className='navba ms-2'  href="/">Vallikunnil Medicals</Navbar.Brand>
          <Nav className="ms-auto">
            <Link to={"/discounts"} style={{textDecoration:'none'}} id= {color?"navbarlinkclass":"navbarlinkchange"} className='navlink' href="/discounts">Discounts & Offers</Link>
            <Link to={"/contact"} style={{textDecoration:'none'}} id={color?"navbarlinkclass1":"navbarlinkchange1"}  className='navlink ms-3' href='contact'>Contact Us</Link>
          </Nav>
        </Container>
      </Navbar>
    </>
  )
}

export default Header